import React from 'react';
import PropTypes from 'prop-types';
import { TextSmall } from '../../../common/text';
import { Logger } from 'common/logger';
import { ChartRow, RowItem } from '../ChartRowAndHeader.styles';

export const TurbineReleaseChartRow = ({ data }) => {
    if (!data || !data.turbineData) {
        Logger.log('No data for TurbineReleaseChartRow');
        return null;
    }
    const turbine = data.turbineData;
    return (
        <ChartRow>
            <RowItem width={100}>
                <TextSmall bold>{data.key}</TextSmall>
            </RowItem>
            <RowItem flex={1}>
                <TextSmall bold>{turbine.awp_nr}</TextSmall>
            </RowItem>
            <RowItem width={200}>
                <TextSmall bold>{turbine.order}</TextSmall>
            </RowItem>
        </ChartRow>
    );
};

TurbineReleaseChartRow.displayName = 'TurbineReleaseChartRow';

TurbineReleaseChartRow.propTypes = {
    data: PropTypes.object,
};

TurbineReleaseChartRow.defaultProps = {};
